import type { PortableTextBlockComponent } from '@portabletext/react';

import { slugifyElement } from '../../../utils/slugify';

const H2: PortableTextBlockComponent = ({ children }) => {
  return (
    <h2
      id={slugifyElement(children)}
      className="mb-6 mt-12 scroll-m-20 text-4xl font-medium first:mt-0"
    >
      {children}
    </h2>
  );
};

export default H2;

export const H2Html: PortableTextBlockComponent = ({ children }) => (
  <h2>{children}</h2>
);
